import { UserPermissionHeader } from 'old/components/user/user-permission-header/user-permission-header'
import { useState } from 'react'
import { Avatar } from 'old/components/avatar/avatar'
import { useTranslate } from 'old/utils'
import { RightOutlined } from '@ant-design/icons'
import { useTeamMembers } from 'old/api'
import { VerticalContainer } from 'old/components/styled'
import { Search } from 'old/components/search/search'
import { theme } from 'antd'
import { VerticalPaginatedList } from 'old/components/vertical-paginated-list/vertical-paginated-list'

type Props = {
    onSelect: (id: string) => void
    onBack: () => void
}

export const UserPermissionResourceSelect = ({ onSelect, onBack }: Props) => {

    //translate:
    const { __ } = useTranslate()

    //theme:
    const { token: { fontSizeSM, margin, paddingXS, paddingLG } } = theme.useToken()

    //state:
    const [ search, setSearch ] = useState(null as string | null)
    
    //resources:
    const {
        data: resources,
        pageNum,
        totalPage,
        isLoading,
        isPreviousData,
        isNextDisabled,
        isPreviousDisabled,
        fetchNext,
        fetchPrevious
    } = useTeamMembers(search, 15)

    //render:
    return (
        <VerticalContainer style={{ height: '100%', paddingBottom: paddingXS, gap: margin }}>

            <VerticalContainer>

                {/* header */}
                <UserPermissionHeader
                    title={__`team_member`}
                    onBack={onBack}
                >
                    <Search
                        placeholder={__`search_team_members`}
                        onSearch={setSearch}
                    />
                </UserPermissionHeader>

            </VerticalContainer>

            <VerticalPaginatedList
                isFirstLoading={isLoading}
                isForbidden={resources === null}
                isError={resources === false}
                notFound={(resources && resources.length === 0) ?? false}
                pageNum={pageNum}
                totalPage={totalPage}
                isPreviousData={isPreviousData}
                isNextDisabled={isNextDisabled}
                isPreviousDisabled={isPreviousDisabled}
                scrollable={true}
                fetchNext={fetchNext}
                fetchPrevious={fetchPrevious}
            >

                {resources && resources.map(resource =>
                    <Avatar
                        key={resource.id}
                        name={resource.name}
                        image={resource.image.path}
                        description={resource.email}
                        extraIcon={<RightOutlined style={{ fontSize: fontSizeSM }}/>}
                        style={{ width: '100%', paddingLeft: paddingLG, paddingRight: paddingLG, borderRadius: 0 }}
                        onClick={() => onSelect(resource.id)}
                    />
                )}

            </VerticalPaginatedList>

        </VerticalContainer>
    )

}
